var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { FormattedMessage, FormattedDate, useIntl } from "react-intl";
import { Pane, Button, Icon, KeyValue, Row, Col, AccordionSet, Accordion, ConfirmationModal, Loading, Callout, Modal, ModalFooter, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchApiClientById, updateApiClient, deleteApiClient, regenerateApiClientSecret, } from "../api/apiClientService";
import { useModal } from "../utils/useModal";
import { getErrorInfo } from "../utils/getErrorCode";
import { getApiClientErrorMessage } from "../utils/apiClientErrorMessage";
import { getLoadFailureMessageId } from "../utils/getErrorMessageId";
import ActionErrorModal from "../components/ActionErrorModal";
var ApiClientDetailPane = function (_a) {
    var id = _a.id, onClose = _a.onClose;
    var intl = useIntl();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useModal(), isErrorOpen = _b.isOpen, errorMessage = _b.message, openErrorModal = _b.openModal, closeErrorModal = _b.closeModal;
    var _c = React.useState(false), showDeleteModal = _c[0], setShowDeleteModal = _c[1];
    var _d = React.useState(false), showRegenerateModal = _d[0], setShowRegenerateModal = _d[1];
    var _e = React.useState(false), showSecretModal = _e[0], setShowSecretModal = _e[1];
    var _f = React.useState(""), secret = _f[0], setSecret = _f[1];
    var _g = React.useState(false), secretCopied = _g[0], setSecretCopied = _g[1];
    var calloutRef = React.useRef(null);
    var _h = useQuery(["czna-api-clients", "detail", id], function () {
        return fetchApiClientById(ky, id);
    }), client = _h.data, isLoading = _h.isLoading, error = _h.error;
    var toggleEnabledMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!client)
                        return [2 /*return*/];
                    return [4 /*yield*/, updateApiClient(ky, id, { enabled: !client.enabled })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["czna-api-clients"]);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        errorInfo = _a.sent();
                        openErrorModal(getApiClientErrorMessage(errorInfo, intl));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deleteMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteApiClient(ky, id)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["czna-api-clients"]);
            onClose();
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        errorInfo = _a.sent();
                        openErrorModal(getApiClientErrorMessage(errorInfo, intl));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var regenerateMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, regenerateApiClientSecret(ky, id)];
        });
    }); }, {
        onSuccess: function (data) {
            setSecret(data.clientSecret);
            setSecretCopied(false);
            setShowSecretModal(true);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        errorInfo = _a.sent();
                        openErrorModal(getApiClientErrorMessage(errorInfo, intl));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConfirmDelete = function () {
        setShowDeleteModal(false);
        deleteMutation.mutate();
    };
    var handleConfirmRegenerate = function () {
        setShowRegenerateModal(false);
        regenerateMutation.mutate();
    };
    var handleCopySecret = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(secret)];
                case 1:
                    _c.sent();
                    setSecretCopied(true);
                    (_b = calloutRef.current) === null || _b === void 0 ? void 0 : _b.sendCallout({
                        type: "success",
                        message: intl.formatMessage({
                            id: "ui-czna-users.apiClients.secret.copied",
                        }),
                    });
                    return [3 /*break*/, 3];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var actionMenu = function (_a) {
        var onToggle = _a.onToggle;
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    toggleEnabledMutation.mutate();
                } },
                React.createElement(Icon, { icon: (client === null || client === void 0 ? void 0 : client.enabled) ? "cancel" : "check-circle" }, (client === null || client === void 0 ? void 0 : client.enabled) ? (React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.disable" })) : (React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.enable" })))),
            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    setShowRegenerateModal(true);
                } },
                React.createElement(Icon, { icon: "key" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.regenerateSecret" }))),
            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    setShowDeleteModal(true);
                } },
                React.createElement(Icon, { icon: "trash" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.delete" })))));
    };
    var paneContent = function () {
        if (isLoading) {
            return React.createElement(Loading, null);
        }
        if (error || !client) {
            return (React.createElement(FormattedMessage, { id: getLoadFailureMessageId(error, "ui-czna-users.error.notFound") }));
        }
        return (React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.section.general" }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.clientId" }), value: client.clientId })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.name" }), value: client.name }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.description" }), value: client.description || "—" })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.status" }), value: client.enabled ? (React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.enabled" })) : (React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.disabled" })) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.roles" }), value: client.roles && client.roles.length > 0
                                ? client.roles.join(", ")
                                : "—" })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.createdAt" }), value: client.createdAt ? (React.createElement(FormattedDate, { value: client.createdAt, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" })) : ("—") })))),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.section.integration" }) },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.intro" })),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.tokenEndpoint" }), value: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.tokenEndpoint.value" }) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.grantType" }), value: "client_credentials" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.allowedEndpoint" }), value: "POST /api/v1/authorities/import" }))),
                React.createElement("p", { style: { marginTop: "1rem" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.curlHint" })),
                React.createElement("pre", { style: {
                        padding: "0.75rem",
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontFamily: "monospace",
                        fontSize: "0.85rem",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-all",
                    } }, "# 1) ".concat(intl.formatMessage({
                    id: "ui-czna-users.apiClients.integration.curlStep.token",
                }), "\nTOKEN=$(curl -s -X POST \"<KEYCLOAK_URL>/realms/<realm>/protocol/openid-connect/token\" \\\n  -d \"grant_type=client_credentials\" \\\n  -d \"client_id=").concat(client.clientId, "\" \\\n  -d \"client_secret=<CLIENT_SECRET>\" \\\n  | jq -r .access_token)\n\n# 2) ").concat(intl.formatMessage({
                    id: "ui-czna-users.apiClients.integration.curlStep.import",
                }), "\ncurl -s -X POST \"<KONG_URL>/api/v1/authorities/import\" \\\n  -H \"x-okapi-tenant: <realm>\" \\\n  -H \"Authorization: Bearer $TOKEN\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\n    \"type\": \"PERSONAL\",\n    \"sourceSystem\": \"<your-system-id>\",\n    \"sourceIdentifier\": \"<optional-source-record-id>\",\n    \"proposalData\": [\n      {\"field_tag\": \"100\", \"indicator1\": \"1\", \"indicator2\": \" \",\n       \"subfield_code\": \"a\", \"value\": \"Surname, Name\"}\n    ]\n  }'")),
                React.createElement("p", { style: { marginTop: "0.5rem", fontSize: "0.85rem", color: "#555" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.integration.scopeNote" })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Pane, { defaultWidth: "44%", paneTitle: client ? (client.name) : (React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.detail" })), onClose: onClose, dismissible: true, actionMenu: !isLoading && client ? actionMenu : undefined }, paneContent()),
        client && (React.createElement(React.Fragment, null,
            React.createElement(ConfirmationModal, { open: showDeleteModal, heading: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.confirm.delete.title" }), message: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.confirm.delete.message" }), onConfirm: handleConfirmDelete, onCancel: function () { return setShowDeleteModal(false); }, confirmLabel: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.delete" }), isConfirmButtonDisabled: deleteMutation.isLoading }),
            React.createElement(ConfirmationModal, { open: showRegenerateModal, heading: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.confirm.regenerate.title" }), message: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.confirm.regenerate.message" }), onConfirm: handleConfirmRegenerate, onCancel: function () { return setShowRegenerateModal(false); }, confirmLabel: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.actions.regenerateSecret" }), isConfirmButtonDisabled: regenerateMutation.isLoading }),
            React.createElement(Modal, { open: showSecretModal, label: intl.formatMessage({
                    id: "ui-czna-users.apiClients.secret.title",
                }), dismissible: true, onClose: function () { return setShowSecretModal(false); }, footer: React.createElement(ModalFooter, null,
                    React.createElement(Button, { onClick: function () { return setShowSecretModal(false); } },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.cancel" }))) },
                React.createElement("p", { style: { color: "#d00", fontWeight: "bold" } },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.secret.warning" })),
                React.createElement("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginTop: "1rem",
                    } },
                    React.createElement("code", { style: {
                            flex: 1,
                            padding: "0.75rem",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontFamily: "monospace",
                            fontSize: "0.9rem",
                            wordBreak: "break-all",
                        } }, secret),
                    React.createElement(Button, { buttonStyle: "default", onClick: handleCopySecret },
                        React.createElement(Icon, { icon: "clipboard" }, secretCopied ? "✓" : "Copy")))),
            React.createElement(ActionErrorModal, { open: isErrorOpen, message: errorMessage, onClose: closeErrorModal }))),
        React.createElement(Callout, { ref: calloutRef })));
};
export default ApiClientDetailPane;
